import { ReactComponent as FillHistoryIcon } from 'assets/icons/fill-history.svg'
import { ToolBarButton } from 'components/ToolBarButton'

export const FillHistoryButton = () => {
  const handleClick = () => {
    console.info('FILL HISTORY button clicked.')
  }

  return (
    <ToolBarButton
      disabled={false}
      label="FILL HISTORY"
      icon={FillHistoryIcon}
      tooltipText="FILL HISTORY"
      clickCallback={handleClick}
    />
  )
}
